import React from 'react';
import Icon from '../../../components/AppIcon';

const ScoringConfiguration = ({ factors = [] }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-elevation-1">
      <h3 className="text-lg font-semibold text-foreground mb-6">Scoring Factors Configuration</h3>
      {factors?.length === 0 ? (
        <div className="text-center py-8">
          <Icon name="Settings" size={40} className="text-muted-foreground mx-auto mb-3 opacity-40" />
          <p className="text-muted-foreground">No scoring factors configured</p>
        </div>
      ) : (
        <div className="space-y-4">
          {factors?.map((factor, index) => (
            <div key={factor?.id || index} className="flex items-center justify-between p-4 bg-muted/30 rounded-lg">
              <div className="flex-1">
                <p className="font-medium text-foreground">{factor?.name}</p>
                <p className="text-sm text-muted-foreground">{factor?.description}</p>
              </div>
              <div className="flex items-center space-x-3 ml-4">
                <div className="text-right">
                  <p className="text-sm font-bold text-foreground">{factor?.weight}%</p>
                  <p className="text-xs text-muted-foreground">Weight</p>
                </div>
                <div className="w-24 bg-muted rounded-full h-2">
                  <div className="bg-primary h-full rounded-full" style={{ width: `${factor?.weight}%` }} />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ScoringConfiguration;